import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function OrderMissing(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 48 48">
        <path
          d="M11.5 15L9.5 12L24.5 2L40 12L38 15L35 13V36H14V13L11.5 15Z"
          fill="none"
          stroke="#4383CC"
          strokeDasharray="4 2"
        />
        <path
          d="M23.0332 18.5V19H26.4248V18.5H30.207V19H31.4033V19.8662H31.9033V22.3291H31.4033V25.0605H31.9033V27.5234H31.4033V30.2549H31.9033V32.7178H31.4033V33.583H30.207V34.083H26.4248V33.583H23.0332V34.083H19.25V33.583H18.0547V32.7178H17.5547V30.2549H18.0547V27.5234H17.5547V25.0605H18.0547V22.3291H17.5547V19.8662H18.0547V19H19.25V18.5H23.0332Z"
          fill="none"
          stroke="#4383CC"
          strokeLinecap="square"
          strokeDasharray="2 4"
        />
        <path
          d="M42.0169 26.826C41.6197 26.7298 41.2065 26.7249 40.8072 26.8116C40.4079 26.8984 40.0325 27.0748 39.7079 27.3279L30.7625 34.4181C29.9143 35.0868 28.922 35.5387 27.8684 35.736V33.6804C27.8625 33.0937 27.6686 32.5251 27.3162 32.0619C26.9639 31.5987 26.4727 31.2664 25.9178 31.116L21.1021 29.7548C19.4037 29.2769 17.5912 29.4759 16.0308 30.3116L8.36328 34.5267V43.9378L15.3952 42.5443H28.6519C30.366 42.5443 32.0154 41.8754 33.2632 40.6743L43.2384 31.0713C43.5644 30.7569 43.799 30.3565 43.916 29.9142C44.0331 29.472 44.0282 29.0052 43.9017 28.5657C43.7752 28.1261 43.5322 27.731 43.1996 27.4239C42.8669 27.1169 42.4576 26.9099 42.0169 26.826Z"
          fill="#D4E3F3"
        />
        <path
          d="M27.8683 34.3397V35.7346C27.4598 35.8096 27.0456 35.8466 26.6307 35.8453C26.2161 35.8451 25.8022 35.8106 25.3931 35.7422L20.3487 34.8553C20.172 34.8243 20.0146 34.7228 19.9111 34.5732C19.8076 34.4236 19.7665 34.2381 19.7969 34.0575C19.8272 33.8768 19.9264 33.716 20.0728 33.6102C20.2192 33.5044 20.4007 33.4624 20.5774 33.4934L25.6218 34.3809C26.3665 34.5118 27.1287 34.4978 27.8683 34.3397Z"
          fill="#A1C1E6"
        />
        <path
          d="M5 46.0005L10.3807 45.4416C10.7482 45.4203 11.0935 45.2546 11.3442 44.9791C11.5949 44.7036 11.7317 44.3397 11.7259 43.9634L11.1414 33.5891C11.1165 33.3707 11.0457 33.1605 10.9339 32.9726C10.8221 32.7848 10.672 32.6239 10.4937 32.5008C10.3155 32.3778 10.1134 32.2955 9.90118 32.2597C9.68897 32.2238 9.4717 32.2353 9.26421 32.2932L5 33.29V46.0005Z"
          fill="#4383CC"
        />
      </svg>
    </IconContainer>
  )
}
